<header class="lens-app-bar" role="banner" (keydown.escape)="closeMenu()">
  <div class="lens-app-bar__inner">
    <div class="lens-app-bar__start">
      <a class="lens-app-bar__brand" [routerLink]="homeLink">
        <img
          src="/aauLogo.png"
          alt="Addis Ababa University Logo"
          class="lens-app-bar__logo"
        />
        <div class="lens-app-bar__brand-text">
          <span class="lens-app-bar__acronym">CTBE</span>
          <span class="lens-app-bar__fullname">ADDIS ABABA UNIVERSITY</span>
        </div>
      </a>

      <span class="lens-app-bar__product">LENS</span>
    </div>

    <nav
      id="lens-app-bar-nav"
      class="lens-app-bar__nav"
      aria-label="Main navigation"
      [class.lens-app-bar__nav--open]="menuOpen()"
    >
      <ul class="lens-app-bar__links">
        @for (item of navItems; track item.route) {
        <li>
          <a
            class="lens-app-bar__link"
            [routerLink]="routeLink(item.route)"
            ariaCurrentWhenActive="page"
            routerLinkActive="lens-app-bar__link--active"
            [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
            (click)="closeMenu()"
          >
            {{ item.label }}
          </a>
        </li>
        }
      </ul>
    </nav>

    <div class="lens-app-bar__actions">
      <button
        type="button"
        class="lens-app-bar__menu-btn"
        [attr.aria-expanded]="menuOpen()"
        aria-controls="lens-app-bar-nav"
        aria-label="Toggle navigation menu"
        (click)="toggleMenu()"
      >
        <mat-icon>{{ menuOpen() ? "close" : "menu" }}</mat-icon>
      </button>
    </div>
  </div>
</header>
